export const EMPTY_CIVIL_PROCEEDING_INFO_FIELDS = {
  hearingDate: '',
  courtNumber: '',
  dateReceiptRequest: '',
  opposingLawyer: '',
  circonscription: '',
  degreeOfJurisdiction: '',
  victim: null,
  SSIGNED_LAWYER: null,
  receptionDate: '',
  jurisdictionDegreeId: '',
  document: null,
  town: '',
};
export const ALL_STATUS = {
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
};
